import React from 'react'
import Title from '../shared/Title'
import Caption from '../shared/Caption'
import { FormattedMessage } from 'react-intl'
import PropTypes from 'prop-types'
import styles from './_weWill.css'
import runScreen from 'images/app-page/we-will/screens/run.png'
import rideScreen from 'images/app-page/we-will/screens/ride.png'

function WeWill (props) {
  const { slug, name } = props.site

  const screen = slug === 'ride' ? rideScreen : runScreen
  const appName = name || 'MapMyRun'
  const flavorClass = styles[slug] || ''

  return (
    <div className={`${styles.weWill} ${flavorClass}`}>
      <div className={styles.content}>
        <Title>
          <FormattedMessage id='appPage.weWill.title' defaultMessage={`The \n#WeWill \nMovement`} />
        </Title>
        <Caption>
          <FormattedMessage
            id='appPage.weWill.caption'
            defaultMessage={'Join UA { appName } and do big things with the world\'s largest fitness community.'}
            values={ { appName } }
          />
        </Caption>
      </div>
      <div className={styles.screen}>
        <img src={screen} />
      </div>
    </div>
  )
}

WeWill.propTypes = {
  site: PropTypes.object,
}

export default WeWill
